<template>
  <div class="d-flex ai-center:d fd-column:mo as-start text-lg bg-white c-gray70 w-100">
    <span class="m-b-2:mo" selenium="icon-definition-label">What do the icons mean?</span>
    <div class="ITEM-CONTAINER">
      <span
          v-for="(credential, index) in credentials"
          :key="index"
          :selenium="credential.selenium"
          class="d-flex ai-center m-r-1 jc-end:d CREDENTIALS-LIST">
        <div  v-if="credential.iconName" class="CREDENTIAL">
          <vk-icon
              v-tooltip="{
                targetClasses: 'c-white',
                content: credential.description,
              }"
              :name="credential.iconName"
              :size="credential.size"

          />
        </div>
        <div
            v-else
            v-tooltip="{
              targetClasses: 'c-white',
              content: credential.description,
        }">
          <img :src="credential.image" class="BADGE">

        </div>
        {{ credential.title }}
      </span>
    </div>

  </div>
</template>

<script>
const CREDENTIALS_GUIDE = [
  {
    title: 'Rated 5-Stars',
    image: require('@/assets/FiveStarPro.svg'),
    description: 'Pros with a 5-star rating.',
  },
  {
    title: 'Verified Performance',
    image: require('@/assets/TopPro.svg'),
    description: 'Verified top performance.',
  },
  {
    title: 'Insured',
    description: 'States usually require contractors to carry insurance that protects both their customers and employees in case of an accident or problem on the job. When a contractor is insured, he or she carries a general liability policy that covers third-parties from personal injury and property damage losses. Contractors with employees should also carry workers compensation insurance to protect employees if they are hurt at work.',
    image: require('@/assets/InsuredBadge.svg'),
    selenium: 'insured-definition-label',
  },
  {
    title: 'Certified',
    description: 'Requirements vary by location, but many pros must be licensed in order to secure permits and perform work in their trade. When a contractor is licensed, he or she has met state and local standards for training, knowledge, experience, and code compliance in their field.',
    iconName: 'certfied',
    size: 30,
    selenium: 'license-definition-label',
  },
];

export default {
  name: 'credential-guide',
  CREDENTIALS_GUIDE,
  props: {
    showTopPro: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    credentials () {
      if (this.showTopPro) {
        return this.$options.CREDENTIALS_GUIDE;
      }
      return this.$options.CREDENTIALS_GUIDE.filter(option => option.title !== 'Verified Performance');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .CREDENTIAL {
    @include square(30px);
    @include margin-right(1);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

  }
  .ITEM-CONTAINER {
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    justify-content: space-around;

  }
  .CREDENTIALS-LIST {
    @include mobile-only {
      width: 150px;
      margin-bottom: $unit
    }
  }
  .BADGE {
    @include square(30px);
    @include margin-right(1);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: white;
    color: white;
  }
</style>
